export const ROLE_ADMIN = 'admin';
export const ROLE_DOCTOR = 'doctor';
export const ROLE_ASSISTANT = 'assistant';
export const ROLE_LOCAL_PATIENT_ONLY_ACCESS = 'localPatientsOnly';
export const ROLE_HAS_CALENDAR = 'hasCalendar';
